export const $ = (selector, $scope = document) => $scope.querySelector(selector);

export const $$ = (selector, $scope = document) => [...$scope.querySelectorAll(selector)];

export const $uid = () => (performance.now() * 10 ** 13).toString(36);

export const $create = (selector) => {
  const [, tag = 'div', id, classes, attr] = selector.match(/^([a-z]+)?(?:#([^\.]+))?(?:\.([^\[]*))?(?:\[(.*)\])?$/);
  const $el = document.createElement(tag);
  if (!!id) $el[id] = id;
  if (!!classes) $el.className = classes.replace('.', ' ');
  if (!!attr) attr.split('][').forEach(pair => {
    const [, key, , value = ''] = pair.match(/^([^=]*)(?:=(['|"]?)(.*)\2)?$/);
    if (key !== '') $el.setAttribute(key, value);
  });
  return $el;
};

export const $Filter = {
  notNull: (any) => any !== null,
  distinct: (val, i, orig) => orig.indexOf(val) === i,
};

export class $EventEmitter {
  constructor() {
    this._eventHandlers = {};
  }
  on(eventName, listener) {
    if (!(eventName in this._eventHandlers)) this._eventHandlers[eventName] = [];
    this._eventHandlers[eventName].push(listener);
  }
  off(eventName, listener) {
    if (eventName in this._eventHandlers) {
      this._eventHandlers[eventName] = this._eventHandlers[eventName].filter((handler) => listener !== handler);
    }
  }
  async emit(eventName, ...args) {
    if (eventName in this._eventHandlers) {
      for (const handler of this._eventHandlers[eventName]) {
        await handler(...args);
      }
    }
  }
}

export const $wait = (millis) => new Promise(resolve => window.setTimeout(resolve, millis));
